import { createAction } from '@mendeley-internal/lib-js-redux-actions';

export const setLocation = createAction('SET_LOCATION');
export const setNavigatedOnClient = createAction('SET_NAVIGATED_ON_CLIENT');



// WEBPACK FOOTER //
// ./src/universal/ui/actions/location.js